import React, { useState } from "react";
import {
    Box,
    Pagination,
    IconButton,
    TextField,
    InputAdornment,
    Typography,
} from "@mui/material";
import { KeyboardArrowLeft, KeyboardArrowLeftOutlined, KeyboardArrowRight, KeyboardArrowRightOutlined, KeyboardArrowUp, KeyboardArrowDown } from "@mui/icons-material";

export default function CustomPagination({
    totalCount,
    pageSize,
    page,
    onPageChange,
    setCurrentPage,
    onPageSizeChange
}) {

    const totalPages = Math.ceil(totalCount / pageSize);

    const handlePageChange = (event, value) => {
        onPageChange(value);
        setCurrentPage(value);
    };

    const handlePrevClick = () => {
        const newPage = Math.max(page - 1, 1);
        setCurrentPage(newPage);
        onPageChange(newPage);
    };

    const handleNextClick = () => {
        const newPage = Math.min(page + 1, totalPages);
        setCurrentPage(newPage);
        onPageChange(newPage);
    };

    const increasePageSize = () => {
        const newSize = pageSize + 5;
        onPageSizeChange(newSize);
    };

    const decreasePageSize = () => {
        const newSize = Math.max(pageSize - 5, 5);
        onPageSizeChange(newSize);
    };

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                mt: 3,
            }}
        >


            {/* <IconButton
                onClick={handlePrevClick}
                disabled={page === 1}
                sx={{
                    border: "1px solid #E5E9EB",
                    borderRadius: "8px",
                    width: 36,
                    height: 36,
                }}
            >
                <KeyboardArrowLeftOutlined />
            </IconButton> */}

            {/* Pagination */}
            <Pagination
                count={totalPages}
                page={page}
                onChange={handlePageChange}
                siblingCount={1}
                boundaryCount={1}
                variant="text"
                shape="rounded"
                sx={{
                    "& .MuiPaginationItem-root": {
                        fontFamily: "Outfit, sans-serif",
                        color: "#6B7280",
                        fontWeight: 500,
                        "&.Mui-selected": {
                            color: "#0E73F6",
                            backgroundColor: "transparent",
                        },
                    },
                }}
            />


            {/* <IconButton
                onClick={handleNextClick}
                disabled={page === totalPages}
                sx={{
                    border: "1px solid #E5E9EB",
                    borderRadius: "8px",
                    width: 36,
                    height: 36,
                }}
            >
                <KeyboardArrowRightOutlined />
            </IconButton> */}


            <TextField
                value={pageSize}
                InputProps={{
                    readOnly: true,
                    endAdornment: (
                        <InputAdornment position="end">
                            <Box sx={{ display: "flex", flexDirection: "column" }}>
                                <IconButton
                                    size="small"
                                    onClick={increasePageSize}
                                    sx={{
                                        height: 18,
                                        width: 24,
                                        borderRadius: "4px",
                                        "&:hover": { backgroundColor: "#f5f5f5" }
                                    }}
                                >
                                    <KeyboardArrowUp sx={{ fontSize: 16 }} />
                                </IconButton>

                                <IconButton
                                    size="small"
                                    onClick={decreasePageSize}
                                    disabled={pageSize <= 5}
                                    sx={{
                                        height: 18,
                                        width: 24,
                                        borderRadius: "4px",
                                        "&:hover": { backgroundColor: "#f5f5f5" }
                                    }}
                                >
                                    <KeyboardArrowDown sx={{ fontSize: 16 }} />
                                </IconButton>
                            </Box>
                        </InputAdornment>
                    ),
                    sx: {
                        textAlign: "center",
                        fontSize: 14,
                        pr: 1,
                    }
                }}
                sx={{
                    width: 70,
                    "& .MuiOutlinedInput-root": {
                        borderRadius: "8px",
                        height: 36,
                    },
                }}
            />
        </Box>
    );
}